<template>
  <div
      :id="id"
      class="modal fade"
      :data-bs-backdrop="!!backdropStatic ? 'static' : null"
      tabindex="-1"
      aria-hidden="true"
      ref="modal">
    <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
        :class="[this.className, cSize]">
      <div class="modal-content text-white rounded-0">
        <div class="modal-header border-0" :class="[headerClasses]">
          <slot name="modal-header"></slot>

          <button
              type="button"
              class="btn-close"
              aria-label="Close"
              @click="closeModal"
              v-if="!disableClose"
          ><span class="icon icon-close"></span></button>
        </div>

        <div class="modal-body" :class="[bodyClasses]">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "VModal",
  props: {
    id: {
      type: String,
      required: false,
      default: "modal",
    },
    backdropStatic: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: "lg",
    },
    className: {
      type: String,
      required: false,
      default: null,
    },
    disableClose: {
      type: String,
      required: false,
      default: null,
    },
    headerClasses: {
      type: Array,
      required: false,
    },
    bodyClasses: {
      type: Array,
      required: false,
    },
  },
  computed: {
    cSize() {
      let ret = null;

      if (this.size) {
        ret = "modal-" + this.size;
      }

      return ret;
    },
  },
  mounted() {
    this.setup();
    this.open();
  },
  data() {
    return {
      doEmitOnClose: true,
    };
  },
  methods: {
    setup() {
      const modal = this.$refs.modal;

      if (!!modal) {
        this.modal = bootstrap.Modal.getOrCreateInstance(modal);

        modal.addEventListener("hidden.bs.modal", () => {
          if (this.doEmitOnClose) {
            this.$emit("closed");
          }
        });
      }
    },
    open() {
      this.modal.show();
    },
    hide() {
      this.modal.hide();
    },
    hideWithoutEmitting() {
      this.doEmitOnClose = false;
      this.hide();
    },
    closeModal() {
      this.hide();
    },
  },
  beforeUnmount() {
    this.modal.hide();
  },
};
</script>

<style lang="scss" scoped>

$font-size-base: 1rem;
$font-size-base-px: 16;

@import "~@uniqoders/ares/scss/helpers";

.modal-content {
  background: linear-gradient(
          230deg, hsla(0, 0%, 100%, .06) 6.7%, hsla(0, 0%, 100%, 0) 65%), #151515;
  border: rem(1) solid var(--uq-gray-700);
  box-shadow: 0 rem(1) rem(6) rgb(0 0 0 / 25%);

  .btn-close {
    position: absolute;
    top: rem(24);
    right: rem(24);
    border: none;
    background: transparent;
    color: var(--uq-white-rgb);
    transition: all .3s ease-out;

    &:hover {
      opacity: .8;
    }
  }
}
</style>
